//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiCheckboxMarkedOutline,
  mdiChatOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
  mdiLockReset,
  mdiDotsVertical,
  mdiTextBoxEditOutline,
} from '@mdi/js'

// import { useRouter } from '@core/utils'
import { initialAbility } from '@/plugins/acl/config'
import { getCurrentInstance } from '@vue/composition-api'
import { useUtils } from '@core/libs/i18n'
import useCryptoJs from '@/@core/utils/useCryptoJs'
import store from '@/store'

export default {
  props: {
    isPrivate: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    // const { router } = useRouter()
    const { t } = useUtils()
    const vm = getCurrentInstance().proxy
    const { userData } = useCryptoJs()

    const logoutUser = () => {
      // Reset ability
      vm.$ability.update(initialAbility)
      store.dispatch('auth/logoutAction')

      // Redirect to login page
      // router.push({ name: 'public', params: { code } })
    }

    const resolveUserRoleText = role => {
      if (role === 'subscriber' || role === 'F') return 'Facility'
      if (role === 'author' || role === 'R') return 'Representative'
      if (role === 'maintainer') return 'Maintainer'
      if (role === 'editor') return 'Editor'
      if (role === 'admin' || role === 'A') return 'Administrator'

      return 'Administrator'
    }

    return {
      userData,
      logoutUser,
      resolveUserRoleText,
      t,

      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
        mdiLockReset,
        mdiDotsVertical,
        mdiTextBoxEditOutline,
      },
    }
  },
}
